import type { DataSetExtra, IPRChartContext } from "./d";
import {
  getWellFlowingPressureUsingVogelModifiedRate,
  getMaxFlowRateVogelModified,
  getWellFlowingPressure
} from "../../calculations/ipr";
import { Flow_Model_Enum } from "gql/api";

export const getVogelModifiedDataSet = (
  context: IPRChartContext
): DataSetExtra => {
  const {
    wellProperties,
    wellTestFlowRates,
    iterations,
    targetLiquidFlowUnit,
    targetPressureUnit,
    fluidPropertiesAtReservoir,
    desiredLiquidRateSTBD
  } = context;
  const operatingPoint = {
    label: "Operating Point",
    point: { x: 0, y: 0 }
  };
  if (!wellProperties) return { points: [], operatingPoint };
  operatingPoint.point = {
    x: targetLiquidFlowUnit.toThisUnit(desiredLiquidRateSTBD),
    y: targetPressureUnit.toThisUnit(
      getWellFlowingPressure(
        Flow_Model_Enum.VogelModified,
        desiredLiquidRateSTBD,
        wellTestFlowRates.liquidFlowRateSTBD,
        wellProperties.well_test_static_bottom_hole_pressure_psia,
        wellProperties.well_test_producing_bottom_hole_pressure_psia,
        fluidPropertiesAtReservoir.bubblePointPressurePSIA,
        wellTestFlowRates.waterCutRatio
      )
    )
  };
  const step =
    getWellFlowingPressureUsingVogelModifiedRate(
      wellProperties.well_test_static_bottom_hole_pressure_psia,
      wellProperties.well_test_producing_bottom_hole_pressure_psia,
      wellTestFlowRates.liquidFlowRateSTBD,
      0,
      fluidPropertiesAtReservoir.bubblePointPressurePSIA,
      wellTestFlowRates.waterCutRatio
    ) / iterations;

  return {
    title: "Vogel (Modified)",
    xAxisLabel: `Flow (${
      targetLiquidFlowUnit.shortLabel || targetLiquidFlowUnit.label
    })`,
    yAxisLabel: `Pressure (${
      targetPressureUnit.shortLabel || targetPressureUnit.label
    })`,
    points: Array.from({ length: iterations })
      .map((_, i) => {
        const y = step * i;
        const x = getMaxFlowRateVogelModified(
          wellProperties.well_test_static_bottom_hole_pressure_psia,
          wellProperties.well_test_producing_bottom_hole_pressure_psia,
          y,
          wellTestFlowRates.liquidFlowRateSTBD,
          fluidPropertiesAtReservoir.bubblePointPressurePSIA,
          wellTestFlowRates.waterCutRatio
        );

        return {
          x: targetLiquidFlowUnit.toThisUnit(x) || x,
          y: targetPressureUnit.toThisUnit(y) || y
        };
      })
      .filter(pt => pt.x > 0)
      .filter(pt => pt.y > 0),
    operatingPoint
  };
};
